"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configure;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _config = require("../config");

var _config2 = _interopRequireDefault(require("./config"));

var Consts = _interopRequireWildcard(require("../constants"));

var _RefreshTokensTimeout = _interopRequireDefault(require("./tokens/RefreshTokensTimeout"));

var defaultOptions = {
  tokens: (0, _objectSpread2.default)({}, _RefreshTokensTimeout.default.options, {
    persistence: Consts.tokens.persistence.LOCAL
  })
};

var isNotFn = function isNotFn(val) {
  return typeof val !== 'function';
};

function configure() {
  var customConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var customOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var authenticate = customConfig.authenticate,
      refreshTokens = customConfig.refreshTokens,
      shouldRefresh = customConfig.shouldRefresh,
      getAuthUser = customConfig.getAuthUser;
  _config2.default.options = (0, _objectSpread2.default)({}, defaultOptions, customOptions, {
    tokens: (0, _objectSpread2.default)({}, defaultOptions.tokens, customOptions.tokens)
  });

  if (isNotFn(authenticate)) {
    _config2.default.remoteLogin = function (credentials) {
      _config.logger.error("Cannot authenticate use with ".concat(credentials, ": Supply authenticate function first."));

      return {
        user: null,
        tokens: {}
      };
    };
  } else {
    _config2.default.remoteLogin = authenticate;
  }

  if (isNotFn(refreshTokens)) {
    _config2.default.remoteRefreshTokens = function (tokens) {
      _config.logger.error('Cannot refresh tokens. No refresh tokens fn supplied.');

      return tokens;
    };
  } else {
    _config2.default.remoteRefreshTokens = refreshTokens;
  }

  if (isNotFn(shouldRefresh)) {
    _config2.default.detectShouldRefresh = function (error) {
      return !!error;
    };
  } else {
    _config2.default.detectShouldRefresh = shouldRefresh;
  }

  if (isNotFn(getAuthUser)) {
    _config2.default.remoteGetAuthUser = function () {
      if (_config2.default.options.tokens.persistence === Consts.tokens.persistence.LOCAL) {
        _config.logger.error("'getAuthUser' is not a function. Tokens persistence is set to '".concat(Consts.tokens.persistence.LOCAL, "'. Change persistence to '").concat(Consts.tokens.persistence.NONE, "' or provide function for fetching authorized user."));
      }
    };
  } else {
    _config2.default.remoteGetAuthUser = getAuthUser;
  }
}